import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import moment from 'moment';
import _ from 'lodash';

export default function AffiliationListingRoutes($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.affiliationListing', {
		url: '/admin/account/hubs',
		controllerAs: 'vm',
		controller: AffiliationListingCtrl,
		templateUrl: '/ng/hub/Account/Listing/AccountListingCtrl.html?' + window.BUILD,
		permission: ['manage_hubs'],
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Account/Listing/AccountListingCtrl.css'),
			affiliation: ApiResourcify.endpoint('/affiliations/current'),
		},
	});
}

class AffiliationListingCtrl {
	constructor($window, Api, Theme, affiliation) {
		'ngInject';
		this.$window = $window;
		this.Api = Api;
		this.Theme = Theme;
		this.affiliation = affiliation;
		this.search = {};
		this.instances = affiliation.hubs.map(hub => {
			hub.logo = hub.theme.on_light;
			hub.numPosts = '---';
			hub.emails = '---';
			hub.members = '---';
			hub.themeColor1 = hub.theme.link1 ? hub.theme.link1 : '#f0572a';
			return hub;
		});

		this.clientIds = _.pluck(this.instances, 'id');

		this.searchText = '';
		this.sortBy = 'name';

		this.dateStart = moment().subtract(29, 'days').format('YYYY-MM-DD');
		this.dateEnd = moment().format('YYYY-MM-DD');

		this.updatePostCounts();
		this.updateEmailCounts();
		this.updateMemberCounts();
	}

	addEditHub(id) {
		if (id) {
			this.$window.location.href = '/hub#/admin/account/hubs/' + id;
		} else {
			this.Api.post('/clients/create_new').then(clientId => {
				this.$window.location.href = '/hub#/admin/account/hubs/' + clientId;
			});
		}
	}

	applyDateRange() {
		this.updatePostCounts();
		this.updateEmailCounts();
	}

	updatePostCounts() {
		let url = '/affiliations/post_counts';

		const dateRangeQueryString = this._getDateRangeQueryString();
		if (dateRangeQueryString) {
			url += '?' + dateRangeQueryString;
		}

		this.instances.forEach(instance => {
			instance.numPosts = '---';
		});

		this.Api.get(url).then(postCounts => {
			this.instances.forEach(instance => {
				instance.numPosts = parseInt(postCounts[instance.id], 10);
			});
		});
	}

	updateEmailCounts() {
		let url = '/affiliations/email_counts';

		const dateRangeQueryString = this._getDateRangeQueryString();
		if (dateRangeQueryString) {
			url += '?' + dateRangeQueryString;
		}

		this.instances.forEach(instance => {
			instance.emails = '---';
		});

		this.Api.get(url).then(emailCounts => {
			this.instances.forEach(instance => {
				instance.emails = parseInt(emailCounts[instance.id], 10);
			});
		});
	}

	updateMemberCounts() {
		let url = '/affiliations/member_counts';

		this.Api.get(url).then(memberCounts => {
			this.instances.forEach(instance => {
				instance.members = parseInt(memberCounts[instance.id], 10);
			});
		});
	}

	_getDateRangeQueryString() {
		if (!this.dateStart || !this.dateEnd) {
			return '';
		}
		return `since_date=${encodeURIComponent(this.dateStart)}&before_date=${encodeURIComponent(this.dateEnd)}`;
	}
}
